// extracted by mini-css-extract-plugin
module.exports = {"under_approval_tag":"UnderApprovalTag_under_approval_tag__2KepA"};